import { Box, HStack, Text, Flex } from "@chakra-ui/react";
import { FC } from "react";
import { Ico } from "@/assets/icons";
import { colors } from "@/components/Theme/colors";
import { Link } from "react-router-dom";
import { AppRoute } from "@/AppRoute";
import Skeleton from "@/shared/components/atoms/Skeleton/Skeleton";
import { Image } from "@/shared/components/atoms/Image";

interface ChannelHeaderProps {
  coverUrl?: string | null;
}

const ChannelHeader: FC<ChannelHeaderProps> = ({ coverUrl }) => (
  <Flex w="full" flexDir={"column"}>
    <Link to={AppRoute.Channels}>
      <HStack mb={4} spacing={2} color={colors.primary[400]}>
        <Ico.ArrowLeft fontSize="16px" />
        <Text fontWeight="medium">Regresar</Text>
      </HStack>
    </Link>
    <Box
      borderRadius="6px"
      display={{ base: "none", md: "block" }}
      overflow="hidden"
    >
      {coverUrl ? (
        <Image
          src={coverUrl}
          alt="cover"
          w="full"
          h={{ base: "180px", md: "280px" }}
          objectFit="cover"
          fetchWidth={1600}
          quality={90}
        />
      ) : (
        <Skeleton height={{ base: "180px", md: "280px" }} />
      )}
    </Box>
  </Flex>
);

export default ChannelHeader;
